"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumerWebOneLinkParams = void 0;
function consumerWebOneLinkParams(campaignFallbackValue, deepLinkUrl, iosAppStoreUrl, desktopPageUrl) {
    return {
        oneLinkBaseUrl: "https://click.snapchat.com/aVHG",
        pidKeys: ["af_pid", "utm_source"],
        pidFallbackValue: "consumer_web",
        campaignKeys: ["af_c", "utm_campaign"],
        campaignFallbackValue,
        googleClickIdParam: "af_sub1",
        deepLinkUrl,
        iosAppStoreUrl,
        desktopPageUrl,
    };
}
exports.consumerWebOneLinkParams = consumerWebOneLinkParams;
//# sourceMappingURL=OneLinkParams.js.map